import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import { ISystemSetting } from './interfaces';

const basePath = '/systemSettings';

/* eslint-disable implicit-arrow-linebreak */

export const getCurrentSystemSettings = (): AxiosPromise<IApiResponse<Array<ISystemSetting>>> =>
  vaultApi.getInstance().get(`${basePath}/currentSettings/current`);
